export const LOG_ACTION = 'LOG_ACTION'

export const logAction = ({entity, data}) => ({
    type: `${entity} ${LOG_ACTION}`,
    payload: {
        data
    }
})
